var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con-vs-chip overflow-hidden",class:[
        `vs-chip-${_vm.color}`,
        {
            'closable': _vm.closable,
            'con-color': _vm.color,
            'bg-chip-transparent': _vm.transparent
        }
    ],staticStyle:{"display":"-webkit-box"},style:(_vm.styleChip)},[_c('span',{staticClass:"text-chip vs-chip--text"},[_vm._t("default")],2),(_vm.closable)?_c('button',{staticClass:"btn-close vs-chip--close",attrs:{"type":"button"},on:{"click":_vm.closeChip}},[_c('vs-icon',{attrs:{"icon-pack":_vm.iconPack,"icon":_vm.closeIcon}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }